module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_18.294de825.jpg";